module.exports = __webpack_public_path__ + "static/media/ic_check.c8b6e882.svg";